import React from 'react';
import { Container, Form, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

export default function Complete(props) {

    return (
        <Container fluid className="border-class complate-page illustrationCompleteDiv">
            <Row className="justify-content-center pt-4">
                <h4 className="mt-3">
                    <b>Your Policy Review has been submitted</b>
                </h4>
            </Row>
            <Row className="justify-content-center">
                <p className="mt-3 illustrationFont">
                    We will contact you with the results of the policy review as soon as it is ready.
                </p>
            </Row>
            <Form.Group className="text-center pt-4">
                <Button variant="contained" size="medium" color="primary" onClick={() => props.clearFormState()}>
                    REQUEST ANOTHER REVIEW
                </Button>
            </Form.Group>
        </Container>
    )
}

Complete.propTypes = {
    formState: PropTypes.object.isRequired,
};

Complete.DefaultFormState = () => {
    return {
        policyReviewId: '',
    };
};




// WEBPACK FOOTER //
// ./src/components/PolicyReview/TermReview/steps/Complete.js